import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Stack,
  Table,
  Tbody,
  Td,
  Tfoot,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { apiurl } from "APIURL";
import axios from "axios";
import { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getAddQuestionData, setContent } from "redux/slices/AddQuestionSlice";
import {
  selectUpdateFormationData,
  setQuestionToUpdate,
  setTest,
  setTestQuestions,
} from "redux/slices/updateFormationSlice";
import AddQuestion from "views/admin/formations/add/components/test/AddQuestion";
import UpdateQuestionModal from "./UpdateQuestionModal";
//import AddQuestion from "./AddQuestion"

interface AddTestProps {
  submitHandler: (e: React.FormEvent) => void;
  testId: number;
  setTestId: React.Dispatch<React.SetStateAction<number>>;
}
const UpdateTestModal: React.FC<AddTestProps> = ({
  submitHandler,
  testId,
  setTestId,
}: AddTestProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useAppDispatch();
  const test = useAppSelector(selectUpdateFormationData).test;
  const { content } = useAppSelector(getAddQuestionData);
  const questions = useAppSelector(selectUpdateFormationData).testQuestions;
  const [loadingQuestions,setLoadingSuestions] = useState(false)
  const toast = useToast();
  const [id, setId] = useState(0);
  const deleteQuestion = (id: number) => {
    dispatch(setTestQuestions(questions.filter((item) => item.id != id)));
  };
  const addQuestionSubmitHandler = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const addQuestionResponse = await axios.post(`${apiurl}/question`, {
        content,
        questionTypeId: 1,
        lastModifiedOn: new Date(),
        responseTimeout: 60,
        testId: test.id,
      });
      //console.log({})
      dispatch(setTestQuestions([...questions, addQuestionResponse.data]));
      setId(id + 1);
      toast({
        title: "Question ajouté avec succés",
        status: "success",
      });
      //dispatch(setAnswers([]))
      dispatch(setContent(""));
      console.log(questions);
    } catch (err) {
      toast({
        title: "Erreur d'ajout",
        status: "error",
      });
    }
  };
  const setState = (id: number) => {
    dispatch(setQuestionToUpdate(questions.find((item) => item.id === id)));
  };
  useEffect(() => {
    const getTestQuestions = async (id: number) => {
      setLoadingSuestions(true)
      const res = await axios.get(`${apiurl}/question/test/${id}`);
      dispatch(setTestQuestions(res.data));
      setLoadingSuestions(false)
    };
    getTestQuestions(test.id);
  }, [test.id]);
  return (
    <>
      <Button leftIcon={<AddIcon />} colorScheme={"brand"} onClick={onOpen}>
        Modifier le test
      </Button>

      <Modal
        closeOnOverlayClick={false}
        size={"5xl"}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <form action="" onSubmit={submitHandler}>
          <ModalContent>
            <ModalHeader>Ajouter test</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl id="email">
                <FormLabel>Désignation de test</FormLabel>
                <Input
                  value={test.title}
                  onChange={(e) =>
                    dispatch(setTest({ ...test, title: e.target.value }))
                  }
                  borderRadius={"full"}
                  type="text"
                />
              </FormControl>
              <FormControl id="email">
                <FormLabel>Description</FormLabel>
                <Input
                  value={test.description}
                  onChange={(e) =>
                    dispatch(setTest({ ...test, description: e.target.value }))
                  }
                  borderRadius={"full"}
                  type="text"
                />
              </FormControl>

              <Stack my={5} direction="row" spacing={"auto"}>
                <Table variant="striped" colorScheme="brand">
                  <Thead>
                    <Tr>
                      <Th>Contenu</Th>
                      <Th>Action</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {loadingQuestions===true?<Spinner />:
                      questions.map((item) => (
                        <Tr>
                          <Td>{item.content}</Td>
                          <Td>
                            <HStack>
                              <UpdateQuestionModal
                                questionSetter={() => setState(item.id)}
                                id={item.id}
                              />
                              <IconButton
                                icon={<MdDelete />}
                                onClick={() => deleteQuestion(item.id)}
                                colorScheme={"brandScheme"}
                                aria-label={""}
                              />
                            </HStack>
                          </Td>
                        </Tr>
                      ))}
                  </Tbody>
                  <Tfoot>
                    <Tr>
                      <Th>Contenu</Th>
                    </Tr>
                  </Tfoot>
                </Table>
                <AddQuestion
                  id={id}
                  setId={setId}
                  submitHandler={addQuestionSubmitHandler}
                />
              </Stack>
            </ModalBody>

            <ModalFooter>
              <Button
                type="button"
                onClick={(e) => {
                  submitHandler(e);
                  onClose();
                }}
                colorScheme="brand"
                mr={3}
              >
                Enregistrer
              </Button>
              <Button onClick={onClose}>Annuler</Button>
            </ModalFooter>
          </ModalContent>
        </form>
      </Modal>
    </>
  );
};

export default UpdateTestModal;
